import{__module as o}from"../../../../_virtual/classCallCheck.js";var a;(a=o).exports=function(o,a){if(!(o instanceof a))throw new TypeError("Cannot call a class as a function")},a.exports.__esModule=!0,a.exports.default=a.exports;
//# sourceMappingURL=classCallCheck.js.map
